<template>
    <div class="services">
        <section class="page">
            <header class="main">
                <div class="container">
                    <h4>Projects</h4>
                </div>
            </header>
            <div class="page-content">
                <div class="container">
                    <div class="row">
                        <div class="col-12 col-lg-6 col-xl-4">
                            <div class="project">
                                <div class="project-image project-image-center">
                                    <img src="/projects/thumb-mms-1.jpg" alt="">
                                </div>
                                <div class="project title">
                                    <h5>Manhattan Mini Storage</h5>
                                    <p class="tags">
                                        <span>#frontend</span>
                                        <span>#angular</span>
                                        <span>#mobile</span>
                                        <span>#dotnetcore</span>
                                    </p>
                                </div>
                                <router-link class="link" to="/projects/timeduo"></router-link>
                            </div>
                        </div>
                        <div class="col-12 col-lg-6 col-xl-4">
                            <div class="project">
                                <div class="project-image project-image-ipad">
                                    <img src="/projects/thumb-fsp-1.png" alt="">
                                </div>
                                <div class="project title">
                                    <h5>Full Service Storage</h5>
                                    <p class="tags">
                                        <span>#frontend</span>
                                        <span>#angular</span>
                                        <span>#rwd</span>
                                        <span>#dotnetcore</span>
                                    </p>
                                </div>
                                <a href="#" class="link"></a>
                            </div>
                        </div>
                        <div class="col-12 col-lg-6 col-xl-4">
                            <div class="project">
                                <div class="project-image">
                                    <img src="/projects/thumb-zokus-1.jpg" alt="">
                                </div>
                                <div class="project title">
                                    <h5>Zokus</h5>
                                    <p class="tags">
                                        <span>#frontend</span>
                                        <span>#vuejs</span>
                                        <span>#rubyonrails</span>
                                        <span>#aws</span>
                                    </p>
                                </div>
                                <a href="#" class="link"></a>
                            </div>
                        </div>

                        <div class="col-12 col-lg-6 col-xl-4">
                            <div class="project">
                                <div class="project-image project-image-center">
                                    <img src="/projects/thumb-timeduo-1.jpg" alt="">
                                </div>
                                <div class="project title">
                                    <h5>Timeduo</h5>
                                    <p class="tags">
                                        <span>#frontend</span>
                                        <span>#backend</span>
                                        <span>#vuejs</span>
                                        <span>#rwd</span>
                                        <span>#nodejs</span>
                                        <span>#hapijs</span>
                                        <span>#mongodb</span>
                                        <span>#pwa</span>
                                    </p>
                                </div>
                                <a href="#" class="link"></a>
                            </div>
                        </div>
                        <div class="col-12 col-lg-6 col-xl-4">
                            <div class="project">
                                <div class="project-image">
                                    <img src="/projects/thumb-timesheet-1.jpg" alt="">
                                </div>
                                <div class="project title">
                                    <h5>Timesheet Generator</h5>
                                    <p class="tags">
                                        <span>#frontend</span>
                                        <span>#backend</span>
                                        <span>#angularjs</span>
                                        <span>#dotnetcore</span>
                                    </p>
                                </div>
                                <a href="#" class="link"></a>
                            </div>
                        </div>
                        <div class="col-12 col-lg-6 col-xl-4">
                            <div class="project">
                                <div class="project-image">
                                    <img src="/projects/thumb-hmi-1.jpg" alt="">
                                </div>
                                <div class="project title">
                                    <h5>NEED HMI</h5>
                                    <p class="tags">
                                        <span>#frontend</span>
                                        <span>#angularjs</span>
                                        <span>#angular</span>
                                        <span>#nodejs</span>
                                        <span>#socketio</span>
                                        <span>#mongodb</span>
                                    </p>
                                </div>
                                <a href="#" class="link"></a>
                            </div>
                        </div>
                        <div class="col-12 col-lg-6 col-xl-4">
                            <div class="project">
                                <div class="project-image project-image-center">
                                    <img src="/projects/thumb-hingeto-1.jpg" alt="">
                                </div>
                                <div class="project title">
                                    <h5>Hingeto</h5>
                                    <p class="tags">
                                        <span>#frontend</span>
                                        <span>#html5</span>
                                        <span>#less</span>
                                        <span>#bootstrap</span>
                                    </p>
                                </div>
                                <a href="#" class="link"></a>
                            </div>
                        </div>
                        <div class="col-12 col-lg-6 col-xl-4">
                            <div class="project">
                                <div class="project-image project-image-center">
                                    <img src="/projects/thumb-clout-1.jpg" alt="">
                                </div>
                                <div class="project title">
                                    <h5>Clouthunter</h5>
                                    <p class="tags">
                                        <span>#frontend</span>
                                        <span>#html5</span>
                                        <span>#less</span>
                                        <span>#bootstrap</span>
                                    </p>
                                </div>
                                <a href="#" class="link"></a>
                            </div>
                        </div>
                    </div>

                </div>
            </div>
        </section>
    </div>
</template>

<script>
export default {
  name: "projects",
  components: {}
};
</script>
<style lang="scss" scoped>
.project {
  margin-bottom: 4rem;
  position: relative;
  .project-image {
    background: #0c0c0c;
    overflow: hidden;
    width: 100%;
    max-width: 420px;
    height: 315px;
    margin-bottom: 1rem;
    position: relative;
    &:after {
      position: absolute;
      display: block;
      width: 100%;
      height: 100%;
      top: 0;
      left: 0;
      content: "";
      background-color: rgba(0, 0, 0, 0.3);
      opacity: 0;
      transition: opacity 0.2s ease-in-out;
      z-index: 1;
    }
    img {
      transform: scale(1);
      transition: transform 0.4s ease-in-out;
    }
    &.project-image-ipad,
    &.project-image-center {
      display: flex;
      align-items: baseline;
      justify-content: center;
    }
  }
  &:hover {
    .project-image {
      &:after {
        opacity: 1;
      }
      img {
        transform: scale(1.05);
      }
    }
  }
  p.tags {
    span {
      font-weight: 600;
      font-family: "Montserrat";
      display: inline-block;
      margin-right: 0.6rem;
      font-size: 13px;
      color: #bfbfbf;
    }
  }
  a.link {
    width: 100%;
    height: 100%;
    position: absolute;
    z-index: 3;
    display: block;
    top: 0;
    left: 0;
  }
}
</style>
